"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class StorageService extends client_1.RWSService {
    constructor() {
        super(...arguments);
        this.storageType = 'local';
    }
    getStorage(type = null) {
        if (!type) {
            type = this.storageType;
        }
        if (type === 'local') {
            return localStorage;
        }
        else if (type === 'session') {
            return sessionStorage;
        }
        throw new Error('Invalid storage type');
    }
    storage(type) {
        if (type !== 'local' && type !== 'session') {
            throw new Error('Invalid storage type. Use "local" or "session".');
        }
        this.storageType = type;
        return this;
    }
    set(key, value, type = null) {
        this.getStorage(type).setItem(key, value);
        return this;
    }
    setUser(user) {
        this.set('jwt_user', JSON.stringify(user));
        return this;
    }
    setToken(token) {
        this.set('jwt_token', token);
        return this;
    }
    get(key, type = null) {
        return this.getStorage(type).getItem(key);
    }
    getUser() {
        const item = this.getStorage().getItem('jwt_user');
        if (!item || item === null || item === '') {
            return null;
        }
        return JSON.parse(item);
    }
    getToken() {
        return this.getStorage().getItem('jwt_token');
    }
    clear(key) {
        this.getStorage().removeItem(key);
        return this;
    }
    clearUser() {
        this.clear('jwt_token').clear('jwt_user');
        return this;
    }
    clearTutorialUser() {
        this.clear('tutorial_jwt_token').clear('tutorial_jwt_user');
        return this;
    }
}
exports.StorageServiceInstance = StorageService;
exports.default = StorageService.getSingleton();
